import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAppointmentPayoutDetailsNetworkAction } from "../../../redux/actions/PayoutAction";
import CustomPagination from "../../../common/CustomPagination";
import { payOutHeaderValue } from "./AdditionalApptHeader";
import { getNetworkMenuId } from "../../../Utils/types";
import moment from "moment";
import { TotalProveiderMonth } from "./helper";

export const TotalAppointments = ({
  searchFilter,
  providerDetail,
  setProviderDetail,
  setSearchFilter,
  header,
  setHeader,
  setSelectAllFlag,
  setSelectAll,
  showData,
  setShowData,
  setOpenModel,
  openModel,
}) => {
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const [tableIndex, setTableIndex] = useState(null);

  useEffect(() => {
    dispatch(
      GetAppointmentPayoutDetailsNetworkAction({
        ...searchFilter,
        page: 1,
        rows: 10,
        IsPayoutStatus: true,
      })
    );
  }, []);

  return (
    <>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={
                    payoutReducer?.getTotalAppointmentPayout?.length ===
                    providerDetail?.length
                  }
                  onClick={(e) => {
                    if (e.target.checked) {
                      setProviderDetail(
                        payoutReducer?.getTotalAppointmentPayout
                      );
                      setSelectAllFlag(true);
                    } else {
                      setSelectAll(false);
                      setProviderDetail([]);
                      setSelectAllFlag(false);
                    }
                  }}
                  readOnly
                />
              </th>
              {searchFilter?.BusinessType === "CBU" && (
                <>
                  <th style={{ minWidth: "20px" }}>Provider ID/Name</th>
                  <th style={{ textAlign: "center" }}>Client Name</th>
                  <th style={{ textAlign: "center" }}>Case No</th>
                  <th>Customer Name</th>
                  <th style={{ textAlign: "center" }}>Provider Amount</th>
                </>
              )}
              {searchFilter?.BusinessType === "IBU" && (
                <>
                  <th style={{ minWidth: "20px" }}>Provider ID/Name</th>
                  <th style={{ textAlign: "center" }}>Insurer Name</th>
                  <th>Policy Ref No</th>
                  <th>Proposer Name</th>
                  <th>Provider Amount</th>
                </>
              )}
              {header.map((ele) => {
                return (
                  <th
                    className={`${
                      ele === "Test Details" ||
                      ele === "Additional Test" ||
                      ele === "Tests" ||
                      ele === "Package"
                        ? "financeAdditionalTest"
                        : "addHeader"
                    }`}
                  >
                    {ele}
                  </th>
                );
              })}
              <th style={{ textAlign: "center" }}>Status</th>
              <th className="addHeader">Action</th>
              {/* <th className="addHeader">Force Accept</th> */}
            </tr>
          </thead>
          {payoutReducer?.getTotalAppointmentPayout?.length !== 0 && (
            <tbody>
              {payoutReducer?.getTotalAppointmentPayout?.map(
                (ele, itemIndex) => {
                  return (
                    <tr key={itemIndex}>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={providerDetail.some((item) => ele === item)}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setProviderDetail([...providerDetail, ele]);
                            } else {
                              setSelectAllFlag(false);
                              setSelectAll(false);
                              setProviderDetail(
                                providerDetail?.filter((item) => ele !== item)
                              );
                            }
                          }}
                          readOnly
                        />
                      </td>
                      <td style={{ minWidth: "200px" }}>{ele?.providerName}</td>
                      <td style={{ textAlign: "center", minWidth: "200px" }}>
                        {ele?.clientName}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {searchFilter?.BusinessType === "CBU"
                          ? ele?.caseNo
                          : ele?.policyRefNo}
                      </td>
                      <td style={{ minWidth: "200px" }}>{ele?.proposerName}</td>
                      <td className="addHeader">
                        {ele?.providerAmount?.toLocaleString("en-IN")}
                      </td>
                      {header.map((col, index) => {
                        return (
                          <td
                            key={index}
                            className={`${
                              col === "Test Details" || col === "Package"
                                ? "payOutAdditionalTest"
                                : "addHeader"
                            }`}
                          >
                            {col === "Test Details" && ele.tests !== null ? (
                              <>
                                {showData === true && tableIndex === itemIndex
                                  ? ele[payOutHeaderValue[col]]
                                  : ele[payOutHeaderValue[col]]
                                      .split(" ")
                                      ?.slice(0, 10)
                                      ?.join(" ")}
                                <a
                                  id="payOutShowMoreBtn"
                                  onClick={() => {
                                    if (col === "Test Details") {
                                      // setShowData(!showData);
                                      setTableIndex(itemIndex);
                                      setShowData(
                                        showData && tableIndex === itemIndex
                                          ? false
                                          : true
                                      );
                                    }
                                  }}
                                >
                                  {ele[payOutHeaderValue[col]].split(" ")
                                    .length < 20
                                    ? ""
                                    : showData === true &&
                                      tableIndex === itemIndex
                                    ? " view less"
                                    : "...view more"}
                                </a>
                              </>
                            ) : col === "Appointment Closed Date" ? (
                              moment(ele?.appointmentClosedDate).format("ll")
                            ) : col === "Month" ? (
                              TotalProveiderMonth(ele?.year, ele?.month)
                            ) : (
                              ele[payOutHeaderValue[col]]
                            )}
                          </td>
                        );
                      })}
                      <td>
                        <p
                          className={`status-style ${
                            ele?.requestStatus === "Paid" ||
                            ele?.requestStatus === "Advance Paid"
                              ? "approved"
                              : ele?.requestStatus === "Reject By Finance" ||
                                ele?.requestStatus === "Not Paid "
                              ? "rejected"
                              : ele?.requestStatus === "Pending At Finance" ||
                                ele?.requestStatus === "Pending at Network"
                              ? "pendingAtFinance"
                              : ele?.requestStatus === "Pending For Payment"
                              ? "pendingForpayment"
                              : ele?.requestStatus === "Partial Paid"
                              ? "partialPaid"
                              : ele?.requestStatus === "Refund" ||
                                ele?.requestStatus === "Partial Refund" ||
                                ele?.requestStatus === "Refund" ||
                                ele?.requestStatus === "Payment Lost"
                              ? "refundStatus"
                              : ele?.requestStatus === "Pending For Provider"
                              ? "refundStatus"
                              : ele?.requestStatus === "Rejected By Provider"
                              ? "rejected"
                              : "pending"
                          }`}
                        >
                          {" "}
                          {ele?.requestStatus}
                        </p>
                      </td>
                      <td
                        className="addHeader"
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          width: "250px",
                        }}
                      >
                        <button
                          style={{ margin: "auto" }}
                          className="btn search__btn action_export"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#sendToQcModal"
                          disabled={
                            getNetworkMenuId()?.canEdit === false
                              ? true
                              : ele?.isPayoutStatus === false ||
                                ele?.isInvoiceGenerated === false ||
                                providerDetail.length > 1 ||
                                (ele?.requestStatus !== "Pending At Network" &&
                                  ele?.requestStatus !== "Partial QC")
                              ? true
                              : false
                          }
                          onClick={() => setProviderDetail([ele])}
                        >
                          Send to QC &nbsp;
                          <i class="fa-solid fa-caret-right"></i>
                        </button>
                        <button
                          style={{ margin: "auto" }}
                          className="btn search__btn action_export"
                          type="button"
                          disabled={
                            getNetworkMenuId()?.canEdit === false
                              ? true
                              : ele?.isPayoutStatus === false ||
                                ele?.isInvoiceGenerated === false ||
                                (ele?.requestStatus !== "Pending At Network" && ele?.requestStatus !== "Pending At Finance" && ele?.requestStatus !== "Rejected By Provider")
                              ? true
                              : false
                          }
                          onClick={() => {
                            setOpenModel({
                              ...openModel,
                              adjustAmount: true,
                            });
                            setProviderDetail([ele]);
                          }}
                        >
                          Adjustment
                        </button>
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          )}
        </table>
        {payoutReducer?.getTotalAppointmentPayout?.length === 0 && (
          <p className="noRecordFound">No Record Found</p>
        )}
        <div className="d-flex justify-content-center mt-4">
          {globalReducer?.getTotalCount !== 0 && (
            <CustomPagination
              totalCount={globalReducer?.getTotalCount}
              perPageData={searchFilter?.rows}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              apiCall={GetAppointmentPayoutDetailsNetworkAction}
              IsPayoutStatus={true}
            />
          )}
        </div>
      </div>
    </>
  );
};
